<template>
    <div v-loading="allLoading">
        <div class="query-form-div">
            <el-form :inline="true" :model="queryForm">
                <el-form-item label="单位名称">
                    <el-input size="small" v-model="queryForm.UnitName" placeholder="单位名称" />
                </el-form-item>
                <el-form-item label="姓名">
                    <el-input size="small" v-model="queryForm.UserName" placeholder="姓名" />
                </el-form-item>

                <el-form-item label="身份证">
                    <el-input type="textarea" size="small" rows="3" v-model="queryForm.IDCard" placeholder="身份证，多个用回车分隔" />
                </el-form-item>
                <el-form-item label="身份">
                    <el-input size="small" rows="3" v-model="queryForm.Identity" placeholder="身份" />
                </el-form-item>
                <el-form-item>
                    <el-button size="small" icon="el-icon-search" type="primary" @click="queryData">查询</el-button>
                    <el-button size="small" icon="el-icon-download" @click="generateSelectRow">批量生成</el-button>


                    <!-- <el-dropdown size="mini" style="margin-left: 10px;" @command="handleGenerateCommand">
                        <el-button size="mini">
                            批量生成<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="generateSelected">生成选中</el-dropdown-item>
                            <el-dropdown-item command="generateAll">生成全部</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown> -->

                </el-form-item>

            </el-form>
        </div>
        <div class="body">
            <el-table size="small" border :data="queryCompetitionPersonnel" ref="multipleTable"
                @selection-change="handleSelectionChange" style="width: 100%" height="630">
                <el-table-column type="selection" width="55">
                </el-table-column>
                <el-table-column label="单位名称" width="300">
                    <template slot-scope="scope">
                        <el-input size="small" v-model="scope.row.UnitName" placeholder="单位名称" />
                    </template>
                </el-table-column>
                <el-table-column label="姓名" width="180">
                    <template slot-scope="scope">
                        <el-input size="small" v-model="scope.row.UserName" placeholder="姓名" />
                    </template>
                </el-table-column>
                 <el-table-column label="身份证" width="200">
                    <template slot-scope="scope">
                        <el-input size="small" v-model="scope.row.IDCard" placeholder="身份证" />
                    </template>
                </el-table-column>
                <el-table-column label="身份" width="180">
                    <template slot-scope="scope">
                        <el-input size="small" v-model="scope.row.Identity" placeholder="身份" />
                    </template>
                </el-table-column>
                <el-table-column label="有效期" width="250">
                    <template slot-scope="scope">
                        <el-input size="small" v-model="scope.row.ValidityDate" placeholder="有效期" />
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="180">
                    <template slot-scope="scope">
                        <!-- <el-button size="small" icon="el-icon-view" @click="generatePass('view', scope.row)"
                            circle></el-button> -->
                        <el-button size="mini" icon="el-icon-download" @click="generatePass('download', scope.row)"
                            circle></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import matchService from '@/request-server/request-services/match-services';
import Url from '../../../request-server/request-url';
export default {
    data() {
        return {
            allLoading: false,
            queryForm: {
                UnitName: '',
                UserName: '',
                Identity:'',
                IDCard: ''
            },
            competitionPersonnel: [],
            queryCompetitionPersonnel: [],
            selectedRows: []

        }
    },
    created() {
        this.initData();
    },

    methods: {
        initData() {
            this.allLoading = true;
            let id = this.$route.params.id;
            this.competitionPersonnel = [];
            matchService.getMatchCompetitionPersonnel({
                matchId: id
            }).then(resData => {
                if (resData.code == 0) {
                    this.competitionPersonnel = resData.data;
                    this.queryData();
                }
            }).finally(() => {
                this.allLoading = false;
            })
        },
        queryData() {
            this.selectedRows = [];
            let cards= this.queryForm.IDCard.split('\n').filter(item => item.trim() != '');
            cards.forEach(item => {
                item = item.trim();
            })
            this.queryCompetitionPersonnel = this.competitionPersonnel.filter(item => {
                return (item.UnitName && item.UnitName.indexOf(this.queryForm.UnitName) > -1) 
                && (item.UserName && item.UserName.indexOf(this.queryForm.UserName) > -1) 
                && (item.Identity && item.Identity.indexOf(this.queryForm.Identity) > -1) 
                && (cards.length == 0 || cards.includes(item.IDCard));
            })
        },
        handleSelectionChange(val) {
            this.selectedRows = val;
        },
        generatePass(type, row) {
            matchService.generateCompetitionPass(row).then(resData => {
                if (resData.code == 0) {
                    window.open(Url.getDownloadBaseUrl() + resData.data, '_blank');
                    this.$message({
                        message: '生成成功',
                        type: 'success'
                    });
                }
            })
        },
        generateSelectRow() {
            if (this.selectedRows.length == 0) {
                this.$message({
                    message: '请选择要生成的人员',
                    type: 'warning'
                });
                return;
            }
            this.allLoading = true;
            matchService.batchGenerateCompetitionPass(this.selectedRows).then(resData => {
                if (resData.code == 0) {
                    console.log(resData.data)
                    window.location.href = Url.getDownloadBaseUrl() + resData.data;
                    this.$message({
                        message: '生成成功',
                        type: 'success'
                    });
                }
            }).finally(() => {
                this.allLoading = false;
            })
        },
        handleGenerateCommand(command) {
            console.log(this.selectedRows)
            if (command == 'generateSelected') {
                if (this.selectedRows.length == 0) {
                    this.$message({
                        message: '请选择要生成的人员',
                        type: 'warning'
                    });
                    return;
                }
                matchService.batchGenerateCompetitionPass(this.selectedRows).then(resData => {
                    if (resData.code == 0) {
                        console.log(resData.data)
                        this.$message({
                            message: '生成成功',
                            type: 'success'
                        });
                    }
                })

            } else if (command == 'generateAll') {
                matchService.batchGenerateCompetitionPass(this.selectedRows).then(resData => {
                    if (resData.code == 0) {
                        console.log(resData.data)
                        this.$message({
                            message: '生成成功',
                            type: 'success'
                        });
                    }
                })
            }
        }

    }
}
</script>
<style lang="scss" scoped>
.query-form-div {
    padding: 12px;
}

.body-div {
    padding: 0 12px;
}

.pagination-div {
    padding: 12px;
    text-align: right;
}

.handle-div {
    padding: 12px;
    text-align: right;
}

i {
    cursor: pointer;
    margin: 0 5px;
    font-size: 16px;
}

.el-icon-delete {
    color: red;
}
</style>
